import { NavigateMessage } from "../types";

export const createNavigateHandler = () => {
  return (message: NavigateMessage) => {
    const viewId = message.viewId?.trim();
    if (!viewId) {
      console.error("[NavigateHandler] Missing viewId in NAVIGATE message");
      return;
    }

    const currentHash = globalThis.location.hash || "";
    if (!currentHash.startsWith("#/_/app/")) {
      console.warn("[NavigateHandler] Ignoring NAVIGATE outside embed app context", { currentHash });
      return;
    }

    const [hashWithoutQuery] = currentHash.split("?");
    const segments = hashWithoutQuery.split("/"); // ['#', '_', 'app', appId, deploymentId, ...]
    if (segments.length < 5) {
      console.warn("[NavigateHandler] Unexpected hash format for NAVIGATE", { currentHash });
      return;
    }

    const appId = segments[3];
    const deploymentId = segments[4];

    let nav = `#/_/app/${appId}/${deploymentId}/${viewId}/`;

    if (message.params && Object.keys(message.params).length > 0) {
      const params = new URLSearchParams();
      Object.entries(message.params).forEach(([key, value]) => {
        let stringValue = "";
        if (value !== null && value !== undefined) {
          if (typeof value === "string" || typeof value === "number" || typeof value === "boolean") {
            stringValue = String(value);
          } else {
            stringValue = JSON.stringify(value);
          }
        }
        params.set(key, stringValue);
      });
      nav += `?${params.toString()}`;
    }

    if (currentHash !== nav) {
      globalThis.location.hash = nav;
    }
  };
};

